import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "sourceName", "targetName", "sourceDetails", "targetDetails", "form"]

  connect() {
    this._hide()
    this._beforeCacheHandler = () => this._hide()
    document.addEventListener("turbo:before-cache", this._beforeCacheHandler)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this._beforeCacheHandler)
  }

  open(event) {
    event.preventDefault()
    const btn = event.currentTarget

    this.sourceNameTarget.textContent = btn.dataset.sourceName
    this.targetNameTarget.textContent = btn.dataset.targetName
    this.sourceDetailsTarget.innerHTML = this.buildDetails(btn, "source")
    this.targetDetailsTarget.innerHTML = this.buildDetails(btn, "target")

    this.formTarget.action = btn.dataset.url

    this.modalTarget.style.display = ""
    document.body.classList.add("overflow-hidden")
  }

  close() {
    this._hide()
  }

  _hide() {
    this.modalTarget.style.display = "none"
    document.body.classList.remove("overflow-hidden")
  }

  closeOnOverlay(event) {
    if (event.target === event.currentTarget) this.close()
  }

  buildDetails(btn, prefix) {
    const account = btn.dataset[`${prefix}Account`] || "—"
    const email = btn.dataset[`${prefix}Email`] || "—"
    const phone = btn.dataset[`${prefix}Phone`] || "—"
    const deals = btn.dataset[`${prefix}Deals`] || "0"
    const activities = btn.dataset[`${prefix}Activities`] || "0"
    const source = btn.dataset[`${prefix}Source`] || ""

    return `
      <div class="flex items-center gap-2 mb-2">
        <span class="text-sm font-medium text-text-primary">${this.escapeHtml(btn.dataset[`${prefix}Name`])}</span>
        ${source ? `<span class="badge-${this.badgeVariant(source)}">${this.escapeHtml(source)}</span>` : ""}
      </div>
      <div class="grid grid-cols-2 gap-x-4 gap-y-1 text-xs text-text-muted">
        <span>Entreprise</span><span class="text-text-secondary">${this.escapeHtml(account)}</span>
        <span>Email</span><span class="text-text-secondary">${this.escapeHtml(email)}</span>
        <span>Téléphone</span><span class="text-text-secondary">${this.escapeHtml(phone)}</span>
        <span>Deals</span><span class="text-text-secondary font-semibold">${deals}</span>
        <span>Activités</span><span class="text-text-secondary font-semibold">${activities}</span>
      </div>
    `
  }

  badgeVariant(source) {
    if (source === "HS+Dendreo") return "success"
    if (source === "HubSpot") return "info"
    if (source === "Dendreo") return "gold"
    return "neutral"
  }

  escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }
}
